import { fork } from "redux-saga/effects";

import map from "./map/index";

/**
 * Root saga that forks all child sagas.
 *
 * @yields Forks the map saga.
 */
const sagas = function* saga() {
    yield fork(map);
};

export default sagas;
